import React from 'react';
import { Box, Card, Typography } from '@mui/joy';
import { PageTreeItem, type PageOption } from './PageTreeItem';

interface PagesStepProps {
  pages: PageOption[];
  onChange: (pages: PageOption[]) => void;
}

export const PagesStep: React.FC<PagesStepProps> = ({ pages, onChange }) => {
  const togglePage = (slug: string, checked: boolean) => {
    const updatePage = (pageList: PageOption[]): PageOption[] => {
      return pageList.map((p) => {
        if (p.slug === slug) {
          return { ...p, checked };
        }
        if (p.children) {
          return { ...p, children: updatePage(p.children) };
        }
        return p;
      });
    };
    
    onChange(updatePage(pages));
  };

  const togglePageAndChildren = (slug: string, checked: boolean) => {
    const updatePageAndChildren = (pageList: PageOption[]): PageOption[] => {
      return pageList.map((p) => {
        if (p.slug === slug) {
          // Toggle this page and all its children
          const toggleChildren = (page: PageOption): PageOption => {
            return {
              ...page,
              checked,
              children: page.children?.map(child => toggleChildren(child))
            };
          };
          return toggleChildren(p);
        }
        if (p.children) {
          return { ...p, children: updatePageAndChildren(p.children) };
        }
        return p;
      });
    };
    
    onChange(updatePageAndChildren(pages));
  };

  return (
    <Box>
      <Typography level="h4" mb={2}>
        Select Your Website Pages
      </Typography>
      <Typography level="body-sm" mb={3}>
        Choose which pages you want to include in your website. You can add or remove pages later.
      </Typography>
      <Card variant="outlined" sx={{ p: 2 }}>
        {pages.map((page) => (
          <PageTreeItem
            key={page.slug}
            page={page}
            onChange={togglePage}
            onToggleAll={togglePageAndChildren}
          />
        ))}
      </Card>
    </Box>
  );
};

export default PagesStep;

